import { complement } from 'ramda'

import { isBlank } from 'utils'

const isPresent = complement(isBlank)

export default isPresent
